import {BracketsTabModel} from "../brackets.tab-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import {CompetitorStandingsPageLinkModel} from "../../../../../containers/competitor-container/pages/standings-page/models/competitor.standings-page.link-model";

export class CompetitorBracketsPageTabModel extends BracketsTabModel {
  @computed get linkModel(): CompetitorStandingsPageLinkModel {
    const linkModel: CompetitorStandingsPageLinkModel = new CompetitorStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.standings, super.itemHashParams(NEW_COMPETITOR_CONTAINER.FILTERS.brackets), this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.hashParams.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_brackets';
  }
}
